/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DocumentDeliveryMethod {
  None = 0,
  Email = 1,
  Sms = 2,
  Fax = 4,
  Pickup = 8,
}
